import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userData: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: state => {
      state.isLoading = true
      state.error = null
    },
    loginSuccess: (state, action) => {
      state.isLoading = false
      state.isAuthenticated = true
      state.userData = action.payload
      state.error = null
    },
    loginFailure: (state, action) => {
      state.isLoading = false
      state.isAuthenticated = false
      state.userData = null
      state.error = action.payload
    },
    logoutSuccess: state => {
      state.isAuthenticated = false
      state.userData = null
      state.error = null
    },
    updateUserData: (state, action) => {
      state.userData = action.payload
    },
  },
})

export const { loginStart, loginSuccess, loginFailure, logoutSuccess, updateUserData } = authSlice.actions

export const selectAuth = state => state.auth
export const selectUser = state => state.auth.userData
export const selectIsAuthenticated = state => state.auth.isAuthenticated

export default authSlice.reducer
